import initializeWithUser from './initializeWithUser';

export default function onLogIn(user) {
  initializeWithUser(user);
}
